// extracted by mini-css-extract-plugin
export default {"melodyVideo":"nM-z","isFullWidth":"oM-z","landingPageVideo":"pM-z","play":"qM-z","iframeVideo":"rM-z","playHidden":"sM-z","fullwidth":"tM-z"};